import React from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import { ThemeInterface, User } from '../../../redux/prop-types';
import {
  isSignedInSelector,
  themeSelector,
  userSelector
} from '../../../redux/selectors';
import MenuButton from './menu-button';
import NavLogo from './nav-logo';
import Points from './points';
import './universal-nav.css';

const mapStateToProps = createSelector(
  isSignedInSelector,
  userSelector,
  themeSelector,
  (isSignedIn, userData: User, theme: ThemeInterface) => ({
    isSignedIn,
    userData,
    theme
  })
);

interface UniversalNavProps {
  fetchState?: { pending: boolean };
  isSignedIn?: boolean;
  userData: User;
  theme?: ThemeInterface;
}

export const UniversalNav = ({
  userData,
  fetchState,
  isSignedIn,
  theme
}: UniversalNavProps): JSX.Element => {
  const { t } = useTranslation();

  const userFirstname = userData?.name?.split(' ')[0];

  return (
    <nav
      aria-label={t('aria.primary-nav')}
      className={'universal-nav'}
      id='universal-nav'
    >
      <div className={'universal-nav-left'}></div>
      <div className='universal-nav-middle'>
        <div id='universal-nav-logo'>
          <NavLogo />
        </div>
      </div>
      <div className='universal-nav-right'>
        {isSignedIn && userData.subscription && (
          <>
            <Points />
            <div id='menu-button-container'>
              <MenuButton
                username={userFirstname}
                userAccess={userData.access}
                fetchState={fetchState}
                theme={theme}
              />
            </div>
          </>
        )}
      </div>
    </nav>
  );
};

UniversalNav.displayName = 'UniversalNav';

export default connect(mapStateToProps)(UniversalNav);
